import _ from 'lodash/fp'
import uuid from 'uuid'
import { all, takeEvery } from 'redux-saga/effects'
import ReactGA from 'react-ga'

import { builder } from '@builder.io/sdk'

import * as AnalyticsReducer from '../reducers/analytics'

//  ███████╗ █████╗  ██████╗  █████╗ ███████╗
//  ██╔════╝██╔══██╗██╔════╝ ██╔══██╗██╔════╝
//  ███████╗███████║██║  ███╗███████║███████╗
//  ╚════██║██╔══██║██║   ██║██╔══██║╚════██║
//  ███████║██║  ██║╚██████╔╝██║  ██║███████║
//  ╚══════╝╚═╝  ╚═╝ ╚═════╝ ╚═╝  ╚═╝╚══════╝

function bookTrackFlow ({ payload }) {
  const id = uuid.v4()
  const item = {
    id,
    sku: `${_.get('id', payload)}`,
    name: `${_.get('title', payload)}`,
    price: _.get('variants.0.priceV2.amount', payload),
    currency: _.get('variants.0.priceV2.currencyCode', payload),
    quantity: 1
  }
  const transaction = {
    id,
    affiliation: `${_.get('vendor', payload)}`,
    revenue: item.price,
    currency: item.currency
  }
  ReactGA.plugin.execute('ecommerce', 'addTransaction', transaction)
  ReactGA.plugin.execute('ecommerce', 'addItem', item)
  ReactGA.plugin.execute('ecommerce', 'send')
}

function shareOpenFlow ({ payload }) {
  ReactGA.event({
    category: 'Social',
    action: 'Open Share',
    label: _.get('label', payload) || 'Uknown social'
  })
}

function shareCloseFlow ({ payload }) {
  ReactGA.event({
    category: 'Social',
    action: 'Close Share',
    label: _.get('label', payload) || 'Uknown social'
  })
}

function routerTrackFlow ({ payload }) {
  const pathname = _.get('location.pathname', payload)
  const searchParams = _.get('location.search', payload)
  ReactGA.pageview(pathname)

  const pId = _.random(1, 6)

  builder.setUserAttributes({
    pId: `"${pId}"`, // Force builder to see pId as a string
    searchParams: searchParams ? `"${searchParams}"` : undefined
  })
}

export default function * () {
  return yield all([
    takeEvery(AnalyticsReducer.types.BOOK, bookTrackFlow),
    takeEvery(AnalyticsReducer.types.SHARE_OPEN, shareOpenFlow),
    takeEvery(AnalyticsReducer.types.SHARE_CLOSE, shareCloseFlow),
    takeEvery('@@router/LOCATION_CHANGE', routerTrackFlow)
  ])
}
